import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.864 5.11a9.996 9.996 0 0 1 15.324 3.96 10.005 10.005 0 0 1 7.737 14.443l-.109.205.775 2.71c.16.56.03 1.159-.339 1.6l-.107.117a1.75 1.75 0 0 1-1.564.482l-.154-.037-2.709-.774-.196.104a10 10 0 0 1-7.623.587l-.314-.109a10 10 0 0 1-5.784-5.472 10 10 0 0 1-3.296-.992l-.225-.119-2.707.775a1.75 1.75 0 0 1-1.465-.235l-.137-.103-.116-.107a1.75 1.75 0 0 1-.482-1.564l.036-.154.774-2.708-.065-.12a10 10 0 0 1 2.29-12.114l.23-.195zm15.967 6.102.007.042a9.98 9.98 0 0 1-1.947 7.882 9.98 9.98 0 0 1-6.853 3.808 8.007 8.007 0 0 0 11.046 2.937 1 1 0 0 1 .65-.13l.134.028 2.675.764-.764-2.675a1 1 0 0 1 .04-.663l.062-.122a8.002 8.002 0 0 0-5.05-11.87M7.091 6.69a7.996 7.996 0 1 1 1.044 13.317l-.231-.133-.12-.059-.127-.041a1 1 0 0 0-.525.006l-2.676.764.765-2.675.028-.133a1 1 0 0 0-.13-.652A7.996 7.996 0 0 1 7.091 6.69"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconLiveChat = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconLiveChat);
export default Memo;
